const ELITE_MARCA = "elite_vacances";
const ELITE_BANNER_NAME_PREFIX = "[EV] ";
const ELITE_TYC_TITLE_PREFIX = "[EV] ";

const ELITE_UPLOAD_DIRS = {
  banners:
    process.env.REACT_APP_ELITE_UPLOAD_DIR_BANNERS || "imagenes_banners_elite",
};

const ELITE_UPLOAD_HOST =
  process.env.REACT_APP_ELITE_UPLOAD_HOST || "storage.elitevacances.com";

const hasEliteBannerPath = (url = "") => {
  const value = String(url).toLowerCase();
  return (
    value.includes(ELITE_UPLOAD_DIRS.banners.toLowerCase()) ||
    value.includes(ELITE_UPLOAD_HOST.toLowerCase())
  );
};

const isEliteBanner = (banner = {}) => {
  if (banner.marca === ELITE_MARCA) return true;
  if (String(banner.name || "").startsWith(ELITE_BANNER_NAME_PREFIX)) return true;

  return [banner.img_mobile, banner.img_tablet, banner.img_pc, banner.img_large].some(
    hasEliteBannerPath,
  );
};

export { ELITE_MARCA, ELITE_TYC_TITLE_PREFIX, ELITE_UPLOAD_DIRS, ELITE_UPLOAD_HOST, isEliteBanner };
